import { useState } from 'react';

interface ViolationData {
  id: string;
  type: string;
  location: string;
  description: string;
  severity: string;
  detectTime: string;
  handled: boolean;
}

export default function SecurityPatrol() {
  const [violations] = useState<ViolationData[]>([
    { id: 'V001', type: '未佩戴安全帽', location: '3号码头作业区', description: '检测到2名作业人员未佩戴安全帽', severity: '高', detectTime: '2025-01-15 09:15', handled: true },
    { id: 'V002', type: '明火告警', location: '仓库区B栋', description: '检测到明火和烟雾', severity: '紧急', detectTime: '2025-01-15 10:30', handled: true },
    { id: 'V003', type: '违规闯入', location: '危险品存储区', description: '未授权人员进入管制区域', severity: '高', detectTime: '2025-01-15 11:45', handled: false },
    { id: 'V004', type: '未穿反光衣', location: '堆场作业区', description: '检测到1名人员未穿反光衣', severity: '中', detectTime: '2025-01-15 08:20', handled: true },
    { id: 'V005', type: '车辆超速', location: '港区主干道', description: '车辆速度超过限速20km/h', severity: '中', detectTime: '2025-01-15 09:50', handled: false },
  ]);

  const totalPatrols = 24;
  const todayViolations = violations.length;
  const unhandled = violations.filter(v => !v.handled).length;
  const emergencyCount = violations.filter(v => v.severity === '紧急').length;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-white">全天候安防巡逻</h2>
        <div className="flex gap-3">
          <button className="px-4 py-2 bg-slate-700 text-white text-sm rounded-lg hover:bg-slate-600 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-volume-up-line mr-2"></i>喊话干预
          </button>
          <button className="px-4 py-2 bg-teal-500 text-white text-sm rounded-lg hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-flight-takeoff-line mr-2"></i>启动巡逻
          </button>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">今日巡逻</span>
            <i className="ri-shield-check-line text-teal-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-white">{totalPatrols}</div>
          <div className="text-xs text-slate-500 mt-1">架次</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">违规事件</span>
            <i className="ri-alert-line text-orange-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-orange-400">{todayViolations}</div>
          <div className="text-xs text-slate-500 mt-1">起</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">待处理</span>
            <i className="ri-time-line text-red-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-red-400">{unhandled}</div>
          <div className="text-xs text-slate-500 mt-1">起</div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-400 text-sm">紧急事件</span>
            <i className="ri-error-warning-line text-red-400 text-xl"></i>
          </div>
          <div className="text-2xl font-bold text-red-400">{emergencyCount}</div>
          <div className="text-xs text-slate-500 mt-1">起</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-white mb-4">实时监控画面</h3>
          <div className="aspect-video bg-slate-900 rounded-lg overflow-hidden relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/2e72103ee78627f4ad9bd2f6057209dd.jpg"
              alt="安防巡逻"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center">
              <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
              实时监控
            </div>
            <div className="absolute top-4 right-4 bg-slate-900/80 backdrop-blur-sm text-white px-3 py-1 rounded-lg text-xs">
              无人机-08
            </div>
            <div className="absolute bottom-4 left-4 right-4 bg-slate-900/80 backdrop-blur-sm rounded-lg p-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-white font-medium">3号码头作业区</span>
                <span className="text-teal-400">AI识别中...</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-white mb-4">违规类型统计</h3>
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-slate-400">未佩戴安全帽</span>
                <span className="text-sm font-medium text-white">35%</span>
              </div>
              <div className="w-full bg-slate-700 rounded-full h-2">
                <div className="bg-orange-500 h-2 rounded-full" style={{ width: '35%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-slate-400">明火烟雾</span>
                <span className="text-sm font-medium text-white">20%</span>
              </div>
              <div className="w-full bg-slate-700 rounded-full h-2">
                <div className="bg-red-500 h-2 rounded-full" style={{ width: '20%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-slate-400">违规闯入</span>
                <span className="text-sm font-medium text-white">25%</span>
              </div>
              <div className="w-full bg-slate-700 rounded-full h-2">
                <div className="bg-orange-500 h-2 rounded-full" style={{ width: '25%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-slate-400">其他违规</span>
                <span className="text-sm font-medium text-white">20%</span>
              </div>
              <div className="w-full bg-slate-700 rounded-full h-2">
                <div className="bg-yellow-500 h-2 rounded-full" style={{ width: '20%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-slate-800/50 border border-slate-700 rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-700">
          <h3 className="text-lg font-semibold text-white">违规事件列表</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-900/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">事件编号</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">违规类型</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">位置</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">描述</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">严重程度</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">检测时间</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">状态</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700">
              {violations.map((violation) => (
                <tr key={violation.id} className="hover:bg-slate-700/30 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white">{violation.id}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{violation.type}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{violation.location}</td>
                  <td className="px-6 py-4 text-sm text-slate-300 max-w-xs truncate">{violation.description}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      violation.severity === '紧急' ? 'bg-red-500/20 text-red-400' :
                      violation.severity === '高' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-yellow-500/20 text-yellow-400'
                    }`}>
                      {violation.severity}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-300">{violation.detectTime}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      violation.handled ? 'bg-teal-500/20 text-teal-400' : 'bg-slate-500/20 text-slate-400'
                    }`}>
                      {violation.handled ? '已处理' : '待处理'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <button className="text-teal-400 hover:text-teal-300 mr-3 cursor-pointer">
                      <i className="ri-eye-line"></i>
                    </button>
                    <button className="text-slate-400 hover:text-slate-300 cursor-pointer">
                      <i className="ri-check-line"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
